import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export default function Gift(props) {
    return (
        <SvgIcon {...props}>
            <path d="M11.8,5.1c0.3-0.2,0.5-0.4,0.8-0.6c0.5-0.5,0.8-1.1,0.9-1.7c0.1-0.7-0.1-1.3-0.5-1.7c-0.3-0.3-0.8-0.5-1.3-0.5
            c-0.7,0-1.5,0.4-2.1,1c-1,1-1.6,2.3-1.9,3.3c-0.2-1-0.7-2.3-1.6-3.2C5.7,1.1,5.1,0.9,4.6,0.9c-0.5,0-0.9,0.2-1.2,0.5
            c-0.7,0.7-0.6,2,0.2,2.9c0.3,0.3,0.7,0.6,1,0.8H1.4v3.8h0.9v6.6h11.4V8.9h0.9V5.1L11.8,5.1L11.8,5.1z M10.4,2.2
            c0.4-0.4,0.9-0.7,1.4-0.7c0.2,0,0.4,0,0.5,0.2c0.4,0.4,0.2,1.3-0.5,1.9c-0.7,0.7-1.5,1.1-2.3,1.4H8.8C9.1,4.2,9.6,3.1,10.4,2.2z
            M3.9,2.7c0-0.1,0-0.4,0.2-0.6C4.2,2,4.4,2,4.6,2l0,0c0.3,0,0.6,0.1,0.9,0.4C6,2.9,6.4,3.7,6.7,4.7c0,0,0,0.1,0,0.1
            c0,0-0.1,0-0.1,0C5.6,4.5,4.8,4,4.3,3.5C4.1,3.3,3.9,3,3.9,2.7z M7.1,14.5H3.3V8.4h3.8V14.5z M7.1,7.9H2.3V6h4.7V7.9z M12.7,14.5
            H8.9V8.4h3.8V14.5z M13.7,7.9H8.9V6h4.7V7.9z"
            />
        </SvgIcon>
    );
}

Gift.defaultProps = {
    viewBox: '0 0 16 16'
};
